import { Trophy, Medal, Shield } from "lucide-react";

export const TIER_META = {
  gold:   { Icon: Trophy, label: "Gold",   icon: "text-amber-400",   badge: "border-amber-400/40 bg-amber-400/10 text-amber-300" },
  silver: { Icon: Medal,  label: "Silver", icon: "text-neutral-300", badge: "border-neutral-500/40 bg-neutral-400/10 text-neutral-300" },
  bronze: { Icon: Shield, label: "Bronze", icon: "text-orange-500",  badge: "border-orange-600/40 bg-orange-600/10 text-orange-400" },
};

export default function TierBadge({ tier, showLabel = true, size = "h-3.5 w-3.5", testid }) {
  const m = TIER_META[tier] || TIER_META.bronze;
  const Icon = m.Icon;
  return (
    <span data-testid={testid}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase ${m.badge}`}>
      <Icon className={`${size} ${m.icon}`} />
      {showLabel && m.label}
    </span>
  );
}
